export default __webpack_public_path__ + "static/media/3536 knife block A top.31c22d15.png";